import axios from 'axios';
import { getMicrosoftGraphAccessToken } from '@/utils/http-client/get-access-token';
import { type UserInfo } from '@/providers/user-info-provider/user-info-context';
import { createPathQueryString } from '@/utils/http-client/url-helpers';

const microsoftGraphApiUrl = 'https://graph.microsoft.com/v1.0';

const httpClient = axios.create({
  baseURL: microsoftGraphApiUrl,
});

httpClient.interceptors.request.use(async (config) => {
  const token = await getMicrosoftGraphAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

interface MicrosoftGraphApi {
  getUserInfo: () => Promise<UserInfo>;
}

export const microsoftGraphApi: MicrosoftGraphApi = {
  getUserInfo: async (): Promise<UserInfo> => {
    const pathParameters = ['me'];

    const response = await httpClient.get<UserInfo>(createPathQueryString({ path: pathParameters }));
    return response.data;
  },
};
